module.exports = __webpack_public_path__ + "images/auto-enable-calendar/calendar-hero.b732539863e77e0efa62.jpg";